/* eslint-disable import/prefer-default-export */
const GW_TO_PAGES_QUERY = [
  'gid',
  'type',
  'locale',
  'country',
  'redirect_uri',
]

const PAGES_TO_GW_QUERY = [
  'feature',
  'response',
  'error_code',
  'error_name',
  'error_message',
]

const WEB_GAME_TO_GW_QUERY = [
  'guid',
  'ticket',
]

export const QUERY_PARAM_TYPE = {
  'IAC.OAUTH': [
    'redirect_uri',
    'client_id',
    'response_type',
    'scope',
    'state', // 클라 위변조 공격 방지
    'extra_response_type', // (옵셔널) /iac/v4/oauth/authorize 로 전달되는 추가 응답 타입
    'client_env', // (옵셔널) /iac/v1/oauth/verify/client 로 전달되는 클라이언트 환경('pc', 'mobile' 등)
    ...PAGES_TO_GW_QUERY,
  ],
  'IAC.TERMS': [
    ...GW_TO_PAGES_QUERY,
    ...PAGES_TO_GW_QUERY,
    ...WEB_GAME_TO_GW_QUERY,
    'without_signout',
    'after_window_close',
    'terms_s_redirect',
    'terms_f_redirect',
    'original_referrer',
  ],
  PLAYNOW: [
    ...GW_TO_PAGES_QUERY,
    ...PAGES_TO_GW_QUERY,
    ...WEB_GAME_TO_GW_QUERY,
  ],
  IIV: [
    ...GW_TO_PAGES_QUERY,
    ...PAGES_TO_GW_QUERY,
    // from Client (연동처)
    'state',
    'target',
    'web_token',

    // from IIV (INSIGN-Front)
    'iiv_key',
    'error_data',
  ],
  'IAL.TWITCH_LINKING': [
    ...GW_TO_PAGES_QUERY,
    ...PAGES_TO_GW_QUERY,
    'support_platforms',
    'twitch_code',
    'link_ticket',
    'target',
  ],
  'IAL.CHZZK_LINKING': [
    ...GW_TO_PAGES_QUERY,
    ...PAGES_TO_GW_QUERY,
    'support_platforms',
    'chzzk_code',
    'link_ticket',
    'target',
    'state',
  ],
  'IAL.DISCOTECH_LINKING': [
    ...GW_TO_PAGES_QUERY,
    ...PAGES_TO_GW_QUERY,
    'link_ticket',
    'code',
    'error',
  ],
  'IAL.PLATFORM_SIGNIN': [
    ...GW_TO_PAGES_QUERY,
    ...PAGES_TO_GW_QUERY,
    'support_platforms',
    'signed_in_by',
    'web_ticket',
    'with_popup_code',
    'use_guest_session',
    'applicationid', // 모바일 연동(GS SDK) 케이스에서 사용
  ],
  'IAL.LOGIN_SELECTOR': [
    ...GW_TO_PAGES_QUERY,
    ...PAGES_TO_GW_QUERY,
    'support_platforms',
    'selected_platform',
    'login_type',
    'code',
    'state',
  ],
  SA: [
    ...GW_TO_PAGES_QUERY,
    ...PAGES_TO_GW_QUERY,
    'cancel_redirect_uri',
  ],
  'SSO.FOR_WEB_GAME': [
    ...GW_TO_PAGES_QUERY,
    ...WEB_GAME_TO_GW_QUERY,
    'target_gid',
    'package_name',
  ],
}
